<ax-text-box [(text)]="value" *ngIf="visible" [placeholder]="placeholder" [readonly]="readonly" >
    <ax-button  (onClick)="direct()">
         <i class="fa-link fas"></i>  
    </ax-button>
</ax-text-box>